import { computed } from "vue";

export function useShare() {

  const canShare = computed(() => {
    return navigator.share !== undefined;
  })

  const share = (url, title, text) => {
    if (canShare.value == true) {
      navigator.share({ title, text, url });
      return true;
    }

    return false;
  }

  return {
    canShare,
    share
  };
}